<template>
  <fragment>
    <div class="main_page">
      <app-navbar></app-navbar>
      <div class="page">
        <loading :active.sync="isPageLoading" is-full-page></loading>
        <div v-if="!isPageLoading">
          <div class="page-title">
            <h1>Trade Agreements</h1>
          </div>
          <div class="page-content">
            <form>
              <div class="form-group row">
                <label for="searchKeyword" class="col-sm-2 col-form-label">Search by Keyword</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="searchKeyword" />
                </div>
                <div class="col-sm-2">
                  <button type="button" class="btn btn-primary" @click="newTradeAgreement">
                    <i class="fas fa-plus-circle"></i> Add New
                  </button>
                </div>
              </div>
            </form>
            <ul class="list-group list-group-flush border-bottom">
              <li class="list-group-item d-flex px-2" v-for="tradeAgreement in searchLocalDataset(getTradeAgreements)" :key="tradeAgreement.id">
                <div class="mr-auto">
                  <p class="m-0">{{ tradeAgreement.name }}</p>
                  <p class="m-0 small-grey">{{ tradeAgreement.code }}</p>
                </div>
                <a role="button" href="#" class="d-flex justify-content-between align-items-center flex-column"
                    title="Edit" @click.prevent="editTradeAgreement(tradeAgreement.id)">
                  <img class="mb-1" src="@/assets/document.svg" alt />
                  <span class="small-grey">Edit</span>
                </a>
                <a role="button" href="#" class="d-flex justify-content-between align-items-center flex-column ml-3"
                    title="Delete" @click.prevent="deleteTradeAgreement(tradeAgreement.id)">
                  <img class="mb-1" src="@/assets/red_x.svg" alt />
                  <span class="small-grey">Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-trade-agreement" size="lg" hide-header hide-footer :no-close-on-backdrop="true">
      <trade-agreement></trade-agreement>
    </b-modal>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MessageBox from "@/utils/messagebox";
import Toast from "@/utils/toast";

export default {
  name: "configuration-trade-agreement",
  components: {
    'app-navbar': () => import('@/components/app-navbar.vue'),
    'trade-agreement': () => import('@/views/configuration/components/trade-agreement.vue')
  },
  data: function() {
    return {
      isPageLoading: true,
      searchKeyword: null
    };
  },
  computed: {
    ...mapGetters(["getTradeAgreements"])
  },
  methods: {
    newTradeAgreement() {
      this.resetTradeAgreement().then(() => {
        this.$bvModal.show("bv-modal-trade-agreement");
      });
    },
    editTradeAgreement(id) {
      this.fetchTradeAgreement(id).then(() => {
        this.$bvModal.show("bv-modal-trade-agreement");
      });
    },
    async deleteTradeAgreement(id) {
      let confirm = await MessageBox.confirm(this, "Remove Trade Agreement", "Are you sure you want to remove trade agreement?");

      if (confirm) {
        this.removeTradeAgreement(id).then(() => {
          Toast.success(this, "Successfully removed trade agreement!");
        });
      }
    },
    searchLocalDataset(values) {
      if (!this.searchKeyword || this.searchKeyword === "") return values;

      return values.filter(i => i.name.includes(this.searchKeyword));
    },
    ...mapActions([ "fetchTradeAgreement", "fetchTradeAgreements", "removeTradeAgreement", "resetTradeAgreement"])
  },
  created: function() {
    this.fetchTradeAgreements().then(() => {
      this.isPageLoading = false;
    });
  }
};
</script>
